import agbHtml from './legal/agbHtml'
import datenschutzHtml from './legal/datenschutzHtml'
import impressumHtml from './legal/impressumHtml'
import widerrufsbelehrungHtml from './legal/widerrufsbelehrungHtml'

const publicHost = process.env.NEXT_PUBLIC_HOST || 'www.designmoebelkaufen.de'

const infos = {

  // Shop-Variablen
  title: 'Designmoebelkaufen',
  name: 'Designmoebelkaufen',
  url: `https://${publicHost}/`,
  email: 'info@moebelzeppenfeld.de',
  telephone: '+49 (2761) 945290',
  fax: '+49 (2761) 945299',
  googleRating: '4,8',
  googleReviewCount: '46',
  googlePlaceId: 'ChIJQ6K_kn6svkcRaqO-QCrqpzc',
  googleReviewHref: 'https://www.google.com/maps/search/?api=1&query=M%C3%B6belhaus%20Zeppenfeld%20Olpe&query_place_id=ChIJQ6K_kn6svkcRaqO-QCrqpzc',
  googlePlaceQuery: 'Möbelhaus Zeppenfeld Olpe',
  publicher: 'Möbelhaus H. Zeppenfeld GmbH',
  priceRange: '$$$', // Wie Teuer sind wir?   1-5  // 1 = Billig  2 = Normal  5 = SUPER-TEUER!!!

  // SHOP INFOS
  description: 'Entdecken Sie kuratierte Designmöbel, Sessel, Wohnaccessoires und Interior-Ideen von Möbel Zeppenfeld für stilvolle Räume und persönliche Einrichtung online.',
  titleAlternate: 'Designmoebelkaufen',
  host: publicHost,
  locale: 'de_DE',
  currency: 'EUR',

  // LEGAL INFOS
  legalowner: 'Sebastian Reither',
  legalrepresentative: 'GF Sebastian Reither',
  legalname: 'Möbelhaus H. Zeppenfeld GmbH',
  street: 'Siegener Str. 23-25',
  postalcode: '57462',
  locality: 'Olpe',
  region: 'Nordrhein-Westfalen',
  regionCode: 'DE-NW',
  countryCode: 'DE',

  registergericht: 'Siegen',
  registernummer: '7053',
  umsatzsteuernr: 'DE298482648',
  disputeResolutionStatement: 'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',

  // Konfiguration
  paymentAfterCheckout: false as boolean, // true = Zahlung nach Bestellung, false = Zahlung vor Bestellung
  siteId: 4,
  containerId: "RN6GPRCp",

  legalPages: {
    agbHtml,
    datenschutzHtml,
    impressumHtml,
    widerrufsbelehrungHtml,
  },

} as const

export default infos
